import React from "react";
import "./Cursor.css";
import useMousePosition from "../../util/useMousePosition";

const Cursor = ({ parentRef, color = "red" }) => {
  const { x, y } = useMousePosition(parentRef);

  return (
    <div
      className={`dot ${color}`}
      style={{ left: `${x}px`, top: `${y}px` }}
    ></div>
  );
};

export default Cursor;
